import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StepperStateToken, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { continueLimit, getMoreMfPortfolio, goHome, onLoad, removeGetMorePortfolio, } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { portfolioListDatastoreBuilder } from '../portfolio_readonly/utils';
import { api } from '../../../configs/api';
import { APP_CONFIG, getAppHeader, isDarkModeTheme } from '../../../configs/config';
import { addCommasToNumber, isFromJupiter, isMorePortfolioRenderCheck, } from '../../../configs/utils';
import _ from 'lodash';
import { commonTemplates } from '../../../configs/common';
import { TextConstants } from '../../../configs/constants';
import { needHelp } from "../../mfFetch/check_limit/actions";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
/*** This will be used to auto trigger removeGetMorePortfolio action when user has already pledged both CAMS and KARVY from UI */
let availableCASX;
let isDarkMode = isDarkModeTheme();
export const template = async (availableCreditAmount, availableCAS, stepResponseObject, shouldShowGetMorePortfolio, totalPortfolioAmount, isEnhancedLimit, isFromJupiterPlatform) => ({
    layout: {
        id: ROUTE.UNLOCK_LIMIT_LANDING,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: "customHeader",
                type: WIDGET.CUSTOM_HEADER,
                position: POSITION.ABSOLUTE_TOP,
            },
            Platform.OS === "ios" ? {} : { id: 'spaceXXL', type: WIDGET.SPACE },
            { id: 'congratulationsText', type: WIDGET.TEXT },
            { id: 'titleText', type: WIDGET.TEXT },
            { id: 'space1', type: WIDGET.SPACE },
            { id: 'amountCard', type: WIDGET.LIMIT_CARD },
            { id: 'space2', type: WIDGET.SPACE },
            { id: 'otherSourceStack', type: WIDGET.STACK },
            { id: 'continue', type: WIDGET.BUTTON },
            { id: 'spaceXXXL', type: WIDGET.SPACE },
            { id: 'divider', type: WIDGET.DIVIDER },
            { id: 'spaceXXXLDuplicate', type: WIDGET.SPACE },
            { id: 'bottomSheetStack', type: WIDGET.STACK },
            { id: 'bs_space0', type: WIDGET.SPACE },
            { id: 'infoRow', type: WIDGET.STACK },
            { id: 'bs_space3', type: WIDGET.SPACE },
            { id: 'divider2', type: WIDGET.DIVIDER },
            shouldShowGetMorePortfolio
                ? { id: 'otherSourceStack', type: WIDGET.STACK }
                : { id: 'skip', type: WIDGET.SPACE },
            { id: 'bs_space2', type: WIDGET.SPACE },
            { id: 'listItem', type: WIDGET.LIST },
        ],
    },
    datastore: {
        congratulationsText: {
            label: 'Congratulations!',
            fontSize: FontSizeTokens.XL,
            fontFamily: FontFamilyTokens.Poppins,
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
            fontWeight: '700',
            lineHeight: 28,
        },
        titleText: {
            label: 'Your portfolio was evaluated successfully',
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            color: isDarkMode ? ColorTokens.Grey_Charcoal : ColorTokens.Grey_Night,
            fontWeight: '400',
            lineHeight: 20,
        },
        customHeader: {
            needHelpAction: {
                routeId: ROUTE.UNLOCK_LIMIT_LANDING,
                type: ACTION.NEED_HELP,
                payload: { id: 'bt_congratsScreen_needHelp', }
            },
            isDarkMode: isDarkMode ? true : false,
            goBackAction: {
                routeId: ROUTE.UNLOCK_LIMIT_LANDING,
                type: ACTION.GO_HOME,
                payload: { id: 'bt_congratsScreen_goBack', }
            },
            hideGoBack: isFromJupiterPlatform ? true : false
        },
        amountCard: {
            id1: 'txt_congratsScreen_limitAmount',
            id2: 'txt_congratsScreen_fetchedAmount',
            isView: false,
            isDarkMode: isDarkMode ? true : false,
            limitAmount: `${addCommasToNumber(parseInt(availableCreditAmount.toString()))}`,
            fetchedAmount: `${addCommasToNumber(parseInt(stepResponseObject['totalPortfolioAmount'].toString()))}`,
            label: isEnhancedLimit ? 'Additional credit limit' : 'Available credit limit',
            secondarylabel: "Fetched mutual funds",
        },
        continue: {
            id: 'bt_congratsScreen_nextStep',
            label: 'Continue to next step',
            type: ButtonTypeTokens.LargeSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            isDarkMode: isDarkMode ? true : false,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
            fontSize: FontSizeTokens.SM,
            action: {
                type: ACTION.UNLOCK_LIMIT,
                routeId: ROUTE.UNLOCK_LIMIT_LANDING,
                payload: {},
            },
        },
        otherSourceStack: {
            type: StackType.column,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'infoText', type: WIDGET.TEXT },
                { id: 'infoButton', type: WIDGET.BUTTON },
            ],
        },
        ...commonTemplates.fetchMoreFromOtherSource('otherSourceStack', {
            type: ACTION.GET_MORE_MF_PORTFOLIO,
            routeId: ROUTE.UNLOCK_LIMIT_LANDING,
            payload: {
                casList: stepResponseObject.availableCAS,
            },
        }).datastore,
        bs_space0: { size: SizeTypeTokens.XL },
        bs_space1: { size: SizeTypeTokens.MD },
        bs_space2: { size: SizeTypeTokens.MD },
        divider: {
            size: DividerSizeTokens.SM,
            color: isDarkMode ? ColorTokens.DARK_MODE_DIVIDER : ColorTokens.Grey_Milk_1,
        },
        space5: { size: SizeTypeTokens.XL },
        bottomSheetStack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.flexStart,
            alignItems: StackAlignItems.center,
            widgetItems: [{ id: 'bottomSheetText', type: WIDGET.TEXT }],
        },
        bottomSheetText: {
            label: 'Credit limit by mutual fund',
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '700',
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
            lineHeight: 24,
        },
        bs_space3: { size: SizeTypeTokens.Size10 },
        infoRow: {
            type: StackType.row,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'col1Header', type: WIDGET.TEXT },
                { id: 'col2Stack', type: WIDGET.STACK },
            ],
        },
        divider2: {
            size: DividerSizeTokens.SM,
            color: isDarkMode ? ColorTokens.DARK_MODE_DIVIDER : ColorTokens.Grey_Milk_1,
        },
        col1Header: {
            label: 'Mutual fund',
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
            lineHeight: 18,
        },
        spaceSM: {
            size: SizeTypeTokens.MD
        },
        col2Stack: {
            type: StackType.row,
            widgetItems: [
                { id: "col2Header", type: WIDGET.TEXT },
                { id: "spaceSM", type: WIDGET.SPACE }
            ]
        },
        col2Header: {
            label: isEnhancedLimit ? 'Additional credit limit' : 'Available credit limit',
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal,
            lineHeight: 18,
        },
        ...(await portfolioListDatastoreBuilder(stepResponseObject)),
        topSpace: { size: SizeTypeTokens.XXXXL },
        space1: { size: SizeTypeTokens.XXXL },
        spaceXXXL: { size: SizeTypeTokens.XXXL },
        spaceXXXLDuplicate: { size: SizeTypeTokens.XXXL },
        spaceXXL: { size: SizeTypeTokens.MD },
        space2: { size: SizeTypeTokens.XL },
        space3: { size: SizeTypeTokens.XL },
        space4: { size: SizeTypeTokens.XL },
        space12: {
            size: SizeTypeTokens.LG
        }
    },
});
export const unlockLimitLandingMFV2 = {
    onLoad: async ({ instrumentTrack, showPopup, network, goBack }) => {
        /*** disable this page for next time to stop Animation ***/
        await SharedPropsService.setPledgeFirstTime(false);
        const updateAvailableCASMap = {};
        const user = await SharedPropsService.getUser();
        const authCAS = await SharedPropsService.getAuthCASResponse();
        let applicationId = "";
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = (await SharedPropsService.getUser())
                .linkedApplications[0].applicationId;
        }
        const pledgeLimitResponse = authCAS
            ? { data: authCAS }
            : await network
                .get(`${api.pledgeLimit}${applicationId}`, {
                headers: await getAppHeader(),
            })
                .then(response => {
                return {
                    data: response.data,
                };
            });
        /*** update authCAS in SharedPropsService if fetched from api ***/
        if (!authCAS && pledgeLimitResponse.data) {
            await SharedPropsService.setAuthCASResponse(pledgeLimitResponse.data);
        }
        const availableCreditAmount = pledgeLimitResponse.data.stepResponseObject.availableCreditAmount ||
            0;
        const totalPortfolioAmount = pledgeLimitResponse.data.stepResponseObject.totalPortfolioAmount ||
            0;
        const availableCAS = pledgeLimitResponse.data.stepResponseObject.availableCAS || [];
        await SharedPropsService.setCasListOriginal(availableCAS);
        const stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        /*** Show popup as soon as we land here if MF_PLEDGE_PORTFOLIO is PENDING_CALLBACK ***/
        const stepStatusMap = pledgeLimitResponse.data.updatedApplicationObj.stepStatusMap;
        if (stepStatusMap.MF_PLEDGE_PORTFOLIO ===
            StepperStateToken.PENDING_CALLBACK) {
            setTimeout(async () => {
                await showPopup({
                    title: `Pledging...`,
                    subTitle: 'Please wait while we confirm your pledge with depository.',
                    type: 'DEFAULT',
                    iconName: IconTokens.Volt,
                });
            }, 250);
            const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
            /***** Starting Polling to check status of MF_PLEDGE_PORTFOLIO *****/
            const PollerRef = setInterval(async () => {
                const mfPledgeStatusResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
                user.linkedApplications[0] = _.get(mfPledgeStatusResponse, 'data');
                await SharedPropsService.setUser(user);
                if (_.get(mfPledgeStatusResponse, 'data.stepStatusMap.MF_PLEDGE_PORTFOLIO') === 'COMPLETED' &&
                    _.get(mfPledgeStatusResponse, 'data.currentStepId') !==
                        'MF_PLEDGE_PORTFOLIO') {
                    clearInterval(PollerRef);
                    await goBack();
                    await showPopup({
                        autoTriggerTimerInMilliseconds: APP_CONFIG.POLLING_INTERVAL,
                        isAutoTriggerCta: true,
                        title: 'Limit unlocked successfully!',
                        subTitle: TextConstants.GENERIC_PROCEED_MESSAGE,
                        type: 'SUCCESS',
                        ctaLabel: 'Continue',
                        primary: true,
                        ctaAction: {
                            type: ACTION.NAV_NEXT,
                            routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                            payload: {
                                stepId: _.get(mfPledgeStatusResponse, 'data.currentStepId'),
                            },
                        },
                    });
                }
            }, APP_CONFIG.POLLING_INTERVAL);
        }
        const isGetMorePortfolio = await isMorePortfolioRenderCheck();
        /*** Prefill pledgeUnit ***/
        stepResponseObject.availableCAS.map((item, index) => {
            let key = `${item.isinNo}-${item.folioNo}`;
            item.pledgedUnits = item.totalAvailableUnits;
            updateAvailableCASMap[key] = item;
        });
        instrumentTrack("GET_PORTFOLIO_SUCCESS_PAGE_VIEWED", { "available_limit": availableCreditAmount });
        await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
        await SharedPropsService.setCreditLimit(availableCreditAmount);
        const isFromJupiterPlatform = await isFromJupiter();
        const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow());
        return Promise.resolve(template(availableCreditAmount, availableCASX, stepResponseObject, isGetMorePortfolio, totalPortfolioAmount, isEnhancedLimit, isFromJupiterPlatform));
    },
    actions: {
        [ACTION.UNLOCK_LIMIT]: continueLimit,
        [ACTION.GET_MORE_MF_PORTFOLIO]: getMoreMfPortfolio,
        [ACTION.REMOVE_GET_MORE_MF_PORTFOLIO]: removeGetMorePortfolio,
        [ACTION.ON_LOAD]: onLoad,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.GO_HOME]: goHome,
    },
    action: {
        routeId: ROUTE.UNLOCK_LIMIT_LANDING,
        payload: {},
        type: ACTION.ON_LOAD,
    },
    clearPrevious: true,
};
